module.exports = __webpack_public_path__ + "static/media/sec.51c03f5b.svg";